export const BaseURL = process.env.NODE_ENV === 'production' ? 'https://fosarica.in/' : 'http://localhost:9000';
